import React from 'react';
import './archiveAnimation.css';

// Morphing archive icon. Two states driven by `morphed`:
//   false → amber box, handle line visible (normal "Archive" affordance)
//   true  → green box with the lid lifted and a tick replacing the handle
//
// All four paths (body, lid, handle, check) are rendered concurrently;
// the .archive-icon--morphed class flips opacity + transforms via the
// shared archiveAnimation.css so the morph runs as a single declarative
// transition (no JS keyframing required).
//
// Pair this with the .archive-button class on the surrounding button so
// the border / text colour shift from amber → green in lockstep with
// the icon.

export default function ArchiveIcon({ morphed = false, size = 14, className = '', ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={`archive-icon ${morphed ? 'archive-icon--morphed' : ''} ${className}`}
      {...rest}
    >
      <path d="M21 8v13H3V8" />
      <path className="archive-icon__lid" d="M1 3h22v5H1z" />
      <line className="archive-icon__handle" x1="10" y1="12" x2="14" y2="12" />
      <polyline className="archive-icon__check" points="8 14 11 17 16 11" />
    </svg>
  );
}
